export const enum DocumentType {
  POD = 'pod',
  BOL = 'bol',
  Invoice = 'invoice',
  RateConfirmation = 'ratecon',
  WeightCertificate = 'weight-certificate',
  InspectionCertificate = 'inspection-certificate',
  Other = 'other',
}

export const enum DocumentStatus {
  Approved = 'approved',
  PendingReview = 'pending-review',
  Denied = 'denied',
  Disputing = 'disputing',
  Legacy = 'legacy',
}

export type Document = {
  name: string
  createdAt: string
  url: string
  total: string
}

export type POD = {
  name: string
  createdAt: string
  url: string
}

export type AgnosticDocument = {
  title: string | number | undefined
  createdAt?: string | null
  type: DocumentType
}
